import { useQueryClient } from '@tanstack/react-query';
import { useNavigate, useRouter } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

import { useAuthState } from '../auth/auth-provider';

/**
 * Lives at the root, above every screen: when a session that was alive ends, the cached server
 * state goes, and an expiry (a refused token or a failed refresh) sends the person to login with
 * the way back to where they were; the login screen says why. A sign-out the person asked for is
 * navigated by its caller. A refusal during the very first load never reaches this component:
 * the app route's loader redirects on its own.
 */
export const SessionWatcher = () => {
  const { status, endedBy } = useAuthState();
  const previous = useRef(status);
  const navigate = useNavigate();
  const router = useRouter();
  const queryClient = useQueryClient();

  useEffect(() => {
    const was = previous.current;
    previous.current = status;
    if (was !== 'authenticated' || status !== 'anonymous') return;
    queryClient.clear();
    if (endedBy !== 'expired') return;
    void navigate({ to: '/login', search: { redirect: router.state.location.href } });
  }, [status, endedBy, navigate, router, queryClient]);

  return null;
};
